import React 		from 'react';
import ReactDOM from 'react-dom';

import BLComponent from '../core/_BLComponent.jsx';

export default class ErrorHandling extends BLComponent {
	constructor(props, context) {
		super(props, context);

		this.state = {
			
		};
	}

	render() {
		return (
			<section>
				<h1 className="text--xxl-title l-margin-bottom--xl">Error Handling</h1>
				<h2 className="text--title l-margin-bottom">Result Code</h2>
				<p>Errors are returned using standard HTTP error code syntax. Any additional info is JSON-formatted and included in the body of the return call.</p>
				<ul>
					<li>A value of 2xx indicates that no errors occurred, and the transaction was successful.</li>
					<li>A value other than 2xx indicates an error.</li>
				</ul>
				<table>
					<tr>
						<th>Code</th>
						<th>Message</th>
						<th>Description</th>
					</tr>
					<tr>
						<td>200</td>
						<td>OK</td>
						<td>A request has been successfully fulfilled.</td>
					</tr>
					<tr>
						<td>201</td>
						<td>OK_CREATED</td>
						<td>A request has been successfully fulfilled and resulted in a creation of a new resource.</td>
					</tr>
					<tr>
						<td>204</td>
						<td>OK_NO_CONTENT</td>
						<td>A request has been successfully processed but does not need to return any data.</td>
					</tr>
					<tr>
						<td>400</td>
						<td>INVALID_URI</td>
						<td>A request has been made to a malformed URL.</td>
					</tr>
					<tr>
						<td>400</td>
						<td>INVALID_REQUEST_BODY</td>
						<td>A request has been made with a malformed JSON body.</td>
					</tr>
					<tr>
						<td>400</td>
						<td>PARAMETER_MISSING_OR_INVALID</td>
						<td>One of the parameters specified is invalid or missing.</td>
					</tr>
					<tr>
						<td>401</td>
						<td>BAD_OAUTH_REQUEST</td>
						<td>Bad OAuth request (wrong consumer key, bad nonce, expired timestamp, etc.). Error message should indicate which one and why.</td>
					</tr>
					<tr>
						<td>403</td>
						<td>PERMISSION_DENIED</td>
						<td>The user is not permitted to make the given request.</td>
					</tr>
					<tr>
						<td>404</td>
						<td>RESOURCE_NOT_FOUND</td>
						<td>The resource you requested does not exist.</td>
					</tr>
					<tr>
						<td>405</td>
						<td>METHOD_NOT_ALLOWED</td>
						<td>The request method is not permitted.</td>
					</tr>
					<tr>
						<td>415</td>
						<td>UNSUPPORTED_MEDIA_TYPE</td>
						<td>The server refused to service the request because the entity of the request is in a format not supported by the requested resource for the requested method.</td>
					</tr>
					<tr>
						<td>422</td>
						<td>RESOURCE_UPDATE_NOT_ALLOWED</td>
						<td>Your post/put request was denied (attempt to update an order status to unavailable value...).</td>
					</tr>
					<tr>
						<td>500</td>
						<td>INTERNAL_SERVER_ERROR</td>
						<td>An unexpected error has occurred in the API.</td>
					</tr>
				</table>
			</section>
		);
	}
}